import React from 'react';
import { DoctorCardWrapper, Header } from "./style";
import useMediaQuery from '@mui/material/useMediaQuery';

// Components
import Image from "next/image";
import Text from 'components/common/Text';
import Link from 'components/common/Link';
import FreeTimesCalendar from 'components/common/FreeTimesCalendar';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// Libs
import Translation from 'libs/Translation';
import ModalManager from 'libs/ModalManager';

const DoctorCard = ({ doctor, specialty, webConfig}) => {
    const mobileView = useMediaQuery('(max-width:700px)');

    const handleViewCalendar = (doctor) => {
            ModalManager.show({
                content: <FreeTimesCalendar 
                            doctor={doctor}
                            webConfig={webConfig} 
                            hideBookButton={true}
                            nextStepButton={true}
                        />,
                title: 
                    <Header>
                        <Image
                            src={doctor?.profileImage ? doctor.profileImage.fileUrl : '/nextasset/images/doctorProfile/Avatar.png'}
                            alt={`${doctor?.Label} ${doctor?.FirstName} ${doctor?.LastName}`}
                            width={58}
                            height={58}
                            className="img"
                        />
                        <div className='column-flex'>
                            <Text
                                className="name"
                            >
                                {`${doctor?.Label ?? ''} ${doctor?.FirstName} ${doctor?.LastName}`}
                            </Text>
                            {specialty?.length ?
                            <Text
                                className='specialties'
                            >
                            {specialty.map((s, i) => 
                            <>
                                {Translation.t('label.specialty-education', {degree: s.EducationLevel, specialty: s.Specialty})}
                                {i !== specialty.length - 1 &&
                                <>
                                    <span>{Translation.t(',')}</span>
                                    {' '}
                                </>
                                }
                            </>
                            )}
                            </Text>
                            : null}  
                        </div>
                    </Header>,
                maxWidth: 'sm',
                background: '#F5F5F7',
                fullScreenMobile: true,
                hideCloseButton: false,
                closable: true,
            })
    }

    return (
    <DoctorCardWrapper 
        key={doctor?.slug}
    >
    <div className='width-100'>
        <div className='row-flex width-100 header'>
            <Link 
                to={`/dr/${doctor?.Slug}`}
                params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
                className="img-container"
            >
                {mobileView ?
                <Image
                    src={doctor?.profileImage ? doctor.profileImage.fileUrl : '/nextasset/images/doctorProfile/Avatar.png'}
                    alt={`${doctor?.Label} ${doctor?.FirstName} ${doctor?.LastName}`}
                    width={65}
                    height={65}
                    className="img"
                />
                :
                <Image
                    src={doctor?.profileImage ? doctor.profileImage.fileUrl : '/nextasset/images/doctorProfile/Avatar.png'}
                    alt={`${doctor?.Label} ${doctor?.FirstName} ${doctor?.LastName}`}
                    width={80}
                    height={80}
                    className="img"
                />
                }
            </Link>
            <div className="doctor-info">
                <Link 
                    to={`/dr/${doctor?.Slug}`}
                    params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
                >
                    <Text
                        tag="h2"
                        className="name"
                    >
                        {`${doctor?.Label ?? ''} ${doctor?.FirstName} ${doctor?.LastName}`}
                    </Text>
                </Link>
                {specialty?.length ?
                <Text
                    className='specialties'
                    tag="h3"
                >
                {specialty.map((s, i) => 
                <>
                    {Translation.t('label.specialty-education', {degree: s.EducationLevel, specialty: s.Specialty})}
                    {i !== specialty.length - 1 &&
                    <>
                    <span>{Translation.t(',')}</span>
                    {' '}
                    </>
                    }
                </>
                )}
                </Text>
                : null}  
            </div> 
        </div>
            
        {doctor?.Services?.length ?
        <>
        <div className='line' />
        <div className='width-100 row-flex gap-6'>
        <span className='label'>
            {Translation.t('title.services')}:
        </span>
        <Text
            className='services'
            tag="h4"
        >
                {doctor.Services.map((s, i) => 
                <>
                {Translation.n(s)}
                {i !== doctor.Services.length - 1 &&
                <>
                <span>/</span>
                {' '}
                </>
                }
                </>
                )}
        </Text>
        </div>
        </>
        : null} 

        <div className='line' />

        <div className='width-100 row-flex footer'>    
            {doctor?.HealthProviderProfiles?.length && doctor?.HealthProviderProfiles[0]?.Address ?
            <div className='address-container row-flex gap-6'>
                <div className='location'>
                {mobileView ?
                <Image
                    src="/nextasset/images/search/location.png"
                    width="16"
                    height="16"
                    alt="location"
                />
                :
                <Image
                    src="/nextasset/images/search/location.png"
                    width="18"
                    height="18"
                    alt="location"
                />
                }
                <span className='label address-label'>
                    {Translation.t('label.address')}
                </span>
                </div>
                <Text
                    tag="h5"
                    className="address"
                >
                    {Translation.n(doctor?.HealthProviderProfiles[0]?.Address)}
                </Text>
            </div>    
            : null    
            }
            <div className='buttons gap-10'>
                <Link
                    to={`/dr/${doctor?.Slug}`}
                    params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
                    className="view-button button"
                >
                    {Translation.t('label.view-profile')}
                </Link>
                <button
                    className="book button"
                    onClick={() => handleViewCalendar(doctor)}
                >
                    {Translation.t('title.get-appointment')} 
                    <KeyboardArrowDownIcon className='icon'/>     
                </button>
            </div>
        </div>
    </div>
    </DoctorCardWrapper>
    )
}

export default DoctorCard;